export const onDialogEditDoneItem = item => ({
  widget: 'models',
  type: 'onDialogEditDoneItem',
  payload: { item },
})



// WEBPACK FOOTER //
// ./src/models/actions/onDialogEditDoneItem.js